import React, { useEffect, useMemo, useRef,useCallback, useState } from "react";
import Chip from '@mui/material/Chip';
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  TextField,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Snackbar,
  Alert,
  Grid,
  Typography,
  MenuItem,
  DialogActions,
  FormControl,
  Select,
  useTheme,
  useMediaQuery
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UnderwritingMessage from "./UnderwritingMessage";
import debounce from 'lodash/debounce';
import {
  CommonYesNo,
  liabbi,
  liabpd,
  Rental,
  Roadside,
  TermTenture,
  umbi,
  umpd,
  medPay,
  coll,
  comp,
  payPlanOptionIns,
  pipDed,
  pipDedOption,
  defaultRates,
} from "../../common/StaticFieldList";
import { CircleOutlined } from "@mui/icons-material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { GridCheckCircleIcon } from "@mui/x-data-grid";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { formattedCurrency } from "../../common/helpers/utils";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import {
  getRates as getJSONAction,
  getEFTByIdAction,
  clearRateErrors,
  convertQuoteToPolicyAction,
  getAllDetialsRatesAction,
  getUnderwritingmsgAction,
} from "../../redux/actions/userActions";
import {
  getcompanyselectionAction,
  getcompanyselectOptionAction,
  getcompanyDetialsAction,
  postCheckedCompanyAction,
  postCheckedCompanyNationalAction,
  getTermAndPlanoptionsAction,
} from "../../redux/actions/companySelectionAction";
import { getAllDriverInfo } from "../../redux/actions/driverInfoActions";
import { getAllVehicleInfo } from "../../redux/actions/vehicleInfoActions";
import getCompanyLogo from "./companyLogos";
import { companyLogos } from "./companyLogos";

const useStyles = makeStyles((theme) => ({
  formContainer: {},
  select: {
    minWidth: 150,
  },
  centerContent: {
    display: "flex",
    alignItems: "center",
  },
  fullWidth: {
    width: "100%",
  },
  root: {
    "& .MuiDataGrid-columnHeaders": {
      borderBottom: "none",
    },
    "& .MuiDataGrid-window": {
      borderTop: "none",
    },
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: '"Poppins", sans-serif',
    id: "table",
  },
  thead: {
    backgroundColor: "#f5f5f5",
    textAlign: "left",
    fontWeight: 600,
    fontSize: "16px",
    id: "thead",
  },
  th: {
    padding: "12px 16px",
    textAlign: "left",
    fontWeight: "500",
    borderBottom: "2px solid #ddd",
    id: "th",
  },
  tbody: {
    fontSize: "14px",
    color: "#333",
    id: "tbody",
  },
  td: {
    padding: "12px 16px",
    borderBottom: "1px solid #ddd",
    fontWeight: "500",
    id: "td",
  },
  actionCell: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    id: "actionCell",
  },
  responsiveTableCell: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      padding: '8px',
    }
  }
}));

const CompareQuotesTab = ({ setShowHideDriverForm, id, flag }) => {
  useEffect(() => {
  const handleScroll = () => {
    // Close all open select dropdowns immediately when scroll starts
    document.querySelectorAll('[aria-expanded="true"]').forEach(element => {
      element.blur();
    });

    // Close Material-UI Popovers/Menus
    document.querySelectorAll('.MuiPopover-root .MuiBackdrop-root').forEach(backdrop => {
      backdrop.click();
    });
  };

  // Add scroll listeners with immediate response
  window.addEventListener('scroll', handleScroll, { passive: true });
  document.addEventListener('scroll', handleScroll, { passive: true, capture: true });

  return () => {
    window.removeEventListener('scroll', handleScroll, { passive: true });
    document.removeEventListener('scroll', handleScroll, { passive: true, capture: true });
  };
}, []);
  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();
  const getGpId = useSelector((state) => state.generalPartyInfo.gpId)
    let quoteId = getGpId;
  const [selectAll, setSelectAll] = useState(false);
  const driverDetails = useSelector((state) => state.driverInfo.allDriverInfo);
  const [isReRated, setIsReRated] = useState(false);
  const [open, setOpen] = useState(false);
  const [allInstallments, setAllInstallments] = useState([]);
  const allVehicles = useSelector((state) => state.user.allVehicles) || [];
    // const normalizedVehciles = Array.isArray(allVehicles)
    // ? allVehicles
    // : [allVehicles];
  const [openError, setOpenError] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  // const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const handleOpenError = () => setOpenError(true);
  const handleCloseError = () => setOpenError(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedCompanyEFT, setSelectedCompanyEFT] = useState(null);
  const [noCompanySelected, setNoCompanySelected] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setSelectedCompany(null);
  };

  const clientName = useSelector(
    (state) => state.generalPartyInfo.allGeneralPartyInfo
  );

  const errorvalue = useSelector((state) => state.user.rateerror) || [];
  const allrates = useSelector((state) => state.user.allRates) || [];
  const underWritingMsg = useSelector((state) => state.user.underWritingMsg) || null;
 const installmentsAmount =
    useSelector((state) => state.user.installment) || [];
  const normalizedRates = Array.isArray(allrates) ? allrates : [allrates];
  const [load, setLoad] = useState(false);

  const [selectedDriver, setSelectedDriver] = useState("");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const loading = useSelector((state) => state.loading.CREATE_USER);
  const options = useSelector((state) => state.companies?.optionList || []);

  const gpId = useSelector((state) => state.companies?.gpId);
  const term = useSelector((state) => state.companies?.term);
  const planOptions = useSelector((state) => state.companies?.planOptions);

  const companies = useSelector((state) => state.companies?.companies || []);
  const companyList = useSelector(
    (state) => state.companies?.companiesList || {}
  );
   const eftvalue = useSelector((state) => {
    const companies = state.companies?.companiesList?.companies || [];
    let allEFTs = [];

    companies.forEach((company) => {
      const name = company.companyName;
      const eft = state.user.eftByCompany?.[name] || [];
      allEFTs = allEFTs.concat(eft);
    });

    return allEFTs;
  });

  const selectedCompanies = companyList?.companies || [];

  const handleOpenDialog = (companyName) => {
    if (!companyName) {
      console.error("Invalid companyName:", companyName);
      return;
    }

    // const selected = allVehicles.find(
    //   (data) => data.vehicleFeesResponse?.companyName === companyName
    // );
const selected = allVehicles.find(
  (data) =>
    data.vehicleDetailsResponseList?.some(
      (vehicle) => vehicle.companyName === companyName
    )
);
    setSelectedCompany(selected || null);
    const CompanyEft = companyList?.companies?.find(
      (data) => data.companyName === companyName
    );
    setSelectedCompanyEFT(CompanyEft || null);
    setOpen(true);
  };

  const [checkedItemss, setCheckedItemss] = useState([]);
  const [openPolicy, setOpenPolicy] = useState(false);
  const [policyNumber, setPolicyNumber] = useState("");
  const [selectedCompanyPolicy, setSelectedCompanyPolicy] = useState("");
  // const priorInsuranceCarriers = useSelector(
  //   (state) => state.priorInsuranceCarriers.priorInsuranceCarriers
  // );

  let priorInsuranceCarriersOptionss = [];
  if (Array.isArray(companyList.companies)) {
    priorInsuranceCarriersOptionss = companyList.companies.map((company) => ({
      value: company.companyName,
      label: company.companyName,
    }));
  }
const abortControllerRef = useRef(null);
const pendingRequestsRef = useRef(new Set());

  const handleOpenPolicy = () => {
    setOpenPolicy(true);
  };

  const handleClosePolicy = () => {
    setOpenPolicy(false);
    setSelectedCompanyPolicy("");
  };

  const handleSubmitPolicy = async() => {
    const payload = {
      gpId: gpId || id,
      companyName: selectedCompanyPolicy,
      policyNumber: policyNumber,
      payPlanOption: formState.payPlanOptions,
      term: formState.term,
    };

    try {
      const result = await dispatch(convertQuoteToPolicyAction(payload));

      if (result) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Policy created successfully",
        });
        setPolicyNumber(" ");
        handleClosePolicy();
      } else {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Failed to create policy",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        severity: "error",
        message: "Something went wrong. Please try again.",
      });
    }
  };

  const initialRows = useMemo(() => {
    if (Array.isArray(companies)) {
      return companies.map((carrier) => ({
        company: carrier.companyName,
        id: carrier.id,
        code: carrier.companyCode,
      }));
    }
    return [];
  }, [companies]);

  const [formState, setFormState] = useState(() => ({
    payPlanOptions: "INS",
    term: "6",
    vehicle: [],
    gpId: id ? parseInt(id) : parseInt(quoteId),
    changeNameInsuredTo: "",
    liabbi: "",
    liabpd: "",
    pipDed: "",
    pipDedOption: "",
    umbi: "",
    umpd: "",
    umStacked: "",
    medPay: "",
  }));

  const [vehicleState, setVehicleState] = useState([]);

  useEffect(() => {
    if (selectedCompanies.length > 0 && companies.length > 0) {
      const checkedIds = selectedCompanies
        .map((company) =>
          companies
            .find((c) => c.companyName === company.companyName)
            ?.id.toString()
        )
        .filter(Boolean);

      if (JSON.stringify(checkedIds) !== JSON.stringify(checkedItemss)) {
        setCheckedItemss(checkedIds);
      }
    }
  }, [selectedCompanies, companies]);

  useEffect(() => {
    dispatch(getcompanyselectionAction());
  }, [dispatch]);

  useEffect(() => {
   const currentId = quoteId || id;
    if (currentId) {
      dispatch(getcompanyselectOptionAction(currentId));
    }
  }, [dispatch, quoteId, id]);

  useEffect(() => {
    const currentId = quoteId || id;;
    if (currentId) {
      dispatch(getcompanyDetialsAction(currentId));
    }
  }, [dispatch, quoteId, id]);

  useEffect(() => {
   const currentId = quoteId || id;;
    if (currentId) {
      dispatch(getTermAndPlanoptionsAction(currentId));
    }
  }, [dispatch, quoteId, id]);

  useEffect(() => {
  const currentId = quoteId || id;;
    if (currentId) {
      dispatch(getAllDriverInfo(currentId));
    }
  }, [dispatch, quoteId, id]);

  useEffect(() => {
   const currentId =quoteId || id;;
    if (currentId) {
      dispatch(getAllVehicleInfo(currentId));
    }
  }, [dispatch, quoteId, id]);

  const apiCallsRef = useRef(new Map());

  useEffect(() => {
    const isValidDispatchCondition =
      Array.isArray(selectedCompanies) &&
      selectedCompanies.length > 0 &&
      gpId &&
      planOptions &&
      term;

    if (!isValidDispatchCondition) {
      return;
    }

    const fetchDataForCompany = async (company) => {
      const companyName = company.companyName;

      if (!companyName) {
        console.warn("Invalid company name for:", company);
        return;
      }

      const trackingKey = `${companyName}-${gpId}-${planOptions}-${term}`;

      if (apiCallsRef.current.get(trackingKey)) {
        return;
      }

      apiCallsRef.current.set(trackingKey, true);

      try {
        const timeout = 30000;

        const apiCalls = [
          dispatch(
            getAllDetialsRatesAction(gpId, planOptions, term, companyName)
          ).catch((error) => {
            console.error(`Error fetching rates for ${companyName}:`, error);
            return null;
          }),
          dispatch(
            getUnderwritingmsgAction(gpId, companyName)
          ).catch((error) => {
            console.error(
              `Error fetching Underwriting details for ${companyName}:`,
              error
            );
            return null;
          }),
          dispatch(
            getEFTByIdAction(gpId, planOptions, term, companyName)
          ).catch((error) => {
            console.error(
              `Error fetching EFT details for ${companyName}:`,
              error
            );
            return null;
          }),
        ];

        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error("API Timeout")), timeout);
        });

        const results = await Promise.race([
          Promise.all(apiCalls),
          timeoutPromise,
        ]);

        const failedCalls = results.filter((result) => result === null).length;
        if (failedCalls > 0) {
          console.warn(`${failedCalls} API calls failed for ${companyName}`);
        }
      } catch (error) {
        console.error(`Failed to fetch data for ${companyName}:`, error);
      } finally {
        apiCallsRef.current.delete(trackingKey);
      }
    };

    const processCompanies = async () => {
      for (const company of selectedCompanies) {
        await fetchDataForCompany(company);
      }
    };

    processCompanies();

    return () => {
      apiCallsRef.current.clear();
    };
  }, [id,planOptions,selectedCompanies]);
// [selectedCompanies, term, planOptions, gpId, dispatch]
  useEffect(() => {
    setFormState((prevState) => ({
      ...prevState,
      term: term || "6",
      payPlanOptions: planOptions || "INS",
    }));
  }, [term, planOptions]);

  const simplifiedDriverDetails = driverDetails.map((driver) => ({
    fullName: `${driver.firstName} ${driver.lastName}`,
  }));

  const firstDriverFullName =
    simplifiedDriverDetails.length > 0
      ? simplifiedDriverDetails[0].fullName
      : "";

  useEffect(() => {
    if (!clientName?.firstName || !clientName?.lastName) return;

    const fullName = `${clientName.firstName} ${clientName.lastName}`;
    setSelectedDriver(fullName);

    setFormState((prevState) => {
      const newState = {
        ...prevState,
        changeNameInsuredTo: options.changeNameInsuredTo || firstDriverFullName,
      };

      if (clientName.state === "TX") {
        return {
          ...newState,
          liabbi: options.liabbi || liabbi[4]?.value || "",
          liabpd: options.liabpd || liabpd[1]?.value || "",
          pipDed: options.pipDed || pipDed[3]?.label || "",
          pipDedOption: options.pipDedOption || pipDedOption[0]?.value || "",
          umbi: options.umbi || umbi[3]?.value || "",
          umpd: options.umpd || umpd[3]?.value || "",
          umStacked: options.umStacked || CommonYesNo[0]?.value || "",
          medPay: options.medPay || umbi[1]?.value || "",
        };
      } else {
        return {
          ...newState,
          liabbi: options.liabbi || liabbi[1]?.value || "",
          liabpd: options.liabpd || liabpd[0]?.value || "",
          pipDed: options.pipDed || pipDed[3]?.label || "",
          pipDedOption: options.pipDedOption || pipDedOption[0]?.value || "",
          umbi: options.umbi || umbi[0]?.value || "",
          umpd: options.umpd || umpd[0]?.value || "",
          umStacked: options.umStacked || CommonYesNo[0]?.value || "",
          medPay: options.medPay || umbi[0]?.value || "",
        };
      }
    });
  }, [clientName, firstDriverFullName, options]);

  const allVehicleInfo = useSelector(
    (state) => state.vehicleInfo.allVehicleInfo
  );

  useEffect(() => {
    if (!allVehicleInfo || allVehicleInfo.length === 0) return;

    const newVehicleObj = allVehicleInfo.map((row) => ({
      id: row.id,
      comp: row.comp || comp[0]?.value,
      coll: row.coll || coll[0]?.value,
      roadside: row.roadside || Roadside[1]?.value,
      rental: row.rental || Rental[1]?.value,
      tow: row.tow || Roadside[1]?.value,
      safety: CommonYesNo[1]?.value || "",
      manufacturer: row.manufacturer,
      model: row.model,
    }));

    if (JSON.stringify(newVehicleObj) !== JSON.stringify(vehicleState)) {
      setVehicleState(newVehicleObj);
      setFormState((prevState) => ({
        ...prevState,
        vehicle: newVehicleObj,
      }));
    }
  }, [allVehicleInfo]);

  useEffect(() => {
    if (initialRows.length > 0) {
      const allIds = initialRows.map((row) => row.id.toString());
      const isAllSelected = allIds.length > 0 && checkedItemss.length === allIds.length;
      if (selectAll !== isAllSelected) {
        setSelectAll(isAllSelected);
      }
    }
  }, [checkedItemss, initialRows]);

  const filteredRates = useMemo(() => {
    const normalizeCompanyName = (name) => name?.toLowerCase().trim();

    const allSelectedCompanies = selectedCompanies.map((company) => ({
      companyName: company.companyName,
    }));

    const selectedCompanyNames = new Set(
      selectedCompanies.map((company) =>
        normalizeCompanyName(company.companyName)
      )
    );

    let validRates = [];

    if (load) {
      if (checkedItemss.length > 0) {
        validRates = defaultRates.filter((rate) => {
          const matchesChecked = checkedItemss.some((item) => {
            const company = initialRows.find(
              (row) => row.id === parseInt(item)
            );
            return (
              company &&
              normalizeCompanyName(rate.companyName) ===
                normalizeCompanyName(company.company)
            );
          });

          const matchesSelected = selectedCompanyNames.has(
            normalizeCompanyName(rate.companyName)
          );

          return matchesChecked && matchesSelected;
        });
      } else {
        validRates = defaultRates.filter((rate) =>
          selectedCompanyNames.has(normalizeCompanyName(rate.companyName))
        );
      }
    } else {
      if (normalizedRates && normalizedRates.length > 0) {
        validRates = normalizedRates.filter((rate) =>
          selectedCompanyNames.has(normalizeCompanyName(rate.companyName))
        );
      } else {
        validRates = defaultRates.filter((rate) =>
          selectedCompanyNames.has(normalizeCompanyName(rate.companyName))
        );
      }
    }

    return allSelectedCompanies.map((company) => {
      const validRate = validRates.find(
        (rate) =>
          normalizeCompanyName(rate.companyName) ===
          normalizeCompanyName(company.companyName)
      );

      if (validRate) {
        return validRate;
      }

      return {
        companyName: company.companyName,
      };
    });
  }, [load, checkedItemss, defaultRates, normalizedRates, selectedCompanies, initialRows]);

  useEffect(() => {
    return () => {
      dispatch(clearRateErrors());
    };
  }, [dispatch]);

  const ratesToDisplay = useMemo(() => {
    const normalizeCompanyName = (name) => name?.toLowerCase().trim();

    return filteredRates.map((rate) => {
      let companyError = null;

      if (errorvalue && !Array.isArray(errorvalue)) {
        if (
          normalizeCompanyName(errorvalue.companyName) ===
          normalizeCompanyName(rate.companyName)
        ) {
          companyError = errorvalue;
        }
      } else if (Array.isArray(errorvalue)) {
        companyError = errorvalue.find(
          (error) =>
            normalizeCompanyName(error.companyName) ===
            normalizeCompanyName(rate.companyName)
        );
      }

      return {
        ...rate,
        hasError: !!companyError,
        errorMessage: companyError?.msgDescription || "",
        hasValidRate: !companyError && rate.totalPremium != null,
      };
    });
  }, [filteredRates, errorvalue]);

  const sortedRates = useMemo(() => {
    return [...ratesToDisplay].sort((a, b) => {
      if (!a.hasValidRate && !b.hasValidRate) return 0;
      if (!a.hasValidRate) return 1;
      if (!b.hasValidRate) return -1;
      return a.depositAmt - b.depositAmt;
    });
  }, [ratesToDisplay]);

  const [openInvoice, setOpenInvoice] = useState(false);

  // const selectedUserId = useSelector((state) => state.user.selectedUserId);
  // const allUser = useSelector((state) => state?.user?.allUser);

  const handleSnackbarClose = () => {
    setSnackbar((prevSnackbar) => ({
      ...prevSnackbar,
      open: false,
    }));
  };

  const handleCheckChanges = (event) => {
    const value = event.target.value;
    setCheckedItemss((prev) => {
      const newChecked = prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value];

      return newChecked;
    });
  };

  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;

    setCheckedItemss((prev) => {
      if (checked) {
        const allIds = initialRows.map((row) => row.id.toString());
        return allIds;
      } else {
        return [];
      }
    });

    setSelectAll(checked);
  };
const debouncedFetchRates = useCallback(
  debounce(async (updatedState, value, name) => {
    // Cancel any pending requests
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create new abort controller for this request
    abortControllerRef.current = new AbortController();

    if (!updatedState.gpId || checkedItemss.length === 0) {
      console.warn("Cannot fetch data: Missing GP ID or no companies selected");
      return;
    }

    dispatch({ type: "RESET_ALL_RATES" });
    dispatch({ type: "CLEAR_RATE_ERRORS" });

    const validCheckedItems = checkedItemss.filter((item) => item != null);
    const nationalGeneralItems = [];
    const otherCompanyItems = [];

    validCheckedItems.forEach((item) => {
      const company = initialRows.find((row) => row.id === parseInt(item));
      if (company && company.company === "National General") {
        nationalGeneralItems.push(item);
      } else if (company) {
        otherCompanyItems.push(item);
      }
    });

    try {
      setLoad(true);
      setNoCompanySelected(false);

      const allPromises = [];

      // Handle National General
      if (nationalGeneralItems.length > 0) {
        const ngPromise = handleNationalGeneralRates(
          nationalGeneralItems,
          validCheckedItems,
          updatedState,
          value,
          name
        );
        allPromises.push(ngPromise);
      }

      // Handle other companies
      if (otherCompanyItems.length > 0) {
        const otherPromise = handleOtherCompaniesRates(
          otherCompanyItems,
          updatedState,
          value,
          name
        );
        allPromises.push(otherPromise);
      }

      await Promise.all(allPromises);

      setIsReRated(true);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error("Error fetching rates:", error);
      }
    } finally {
      setLoad(false);
      abortControllerRef.current = null;
    }
  }, 500), // 500ms debounce delay
  [checkedItemss, initialRows, dispatch]
);
const handleInputChange = (e) => {
  e.preventDefault();
  const { name, value } = e.target;

  setFormState((prevState) => {
    const updatedState = {
      ...prevState,
      [name]: value,
    };

    // Only trigger API calls for specific fields
    if ((name === "payPlanOptions" || name === "term") && updatedState.gpId && checkedItemss.length > 0) {
      // Cancel previous debounced call and make new one
      debouncedFetchRates.cancel();
      debouncedFetchRates(updatedState, value, name);
    }

    return updatedState;
  });

  setSelectedDriver(value);
};

// Separate function for National General handling
const handleNationalGeneralRates = async (
  nationalGeneralItems,
  validCheckedItems,
  updatedState,
  value,
  name
) => {
  const companyNameRequestList = validCheckedItems
    .map((item) => {
      const company = initialRows.find((row) => row.id === parseInt(item));
      return company ? { companyName: company.company } : null;
    })
    .filter((entry) => entry != null);

  if (companyNameRequestList.length === 0) {
    console.error("No valid companies found to process.");
    return;
  }

  const postCheckedData = {
    gpId: updatedState.gpId,
    companyNameRequestList,
  };

  await dispatch(postCheckedCompanyNationalAction(postCheckedData));
  await dispatch(getcompanyDetialsAction(updatedState.gpId));

  const promises = nationalGeneralItems.map((item) => {
    const company = initialRows.find((row) => row.id === parseInt(item));
    if (!company) return null;

    const requestKey = `${company.company}-${updatedState.gpId}-${value}-${updatedState.term}`;

    // Check if this request is already pending
    if (pendingRequestsRef.current.has(requestKey)) {
      return null;
    }

    pendingRequestsRef.current.add(requestKey);

    const payload = {
      ...updatedState,
      companyCode: company.code,
    };

    return getRates(payload, company.company)
      .then(async () => {
        const payPlanValue = name === "payPlanOptions" ? value : updatedState.payPlanOptions;
        const termValue = name === "term" ? value : updatedState.term;

        const [rateResult, installmentResult, eftResult] = await Promise.all([
          dispatch(getAllDetialsRatesAction(payload.gpId, payPlanValue, termValue, company.company)),
          dispatch(getUnderwritingmsgAction(payload.gpId, company.company)),
          dispatch(getEFTByIdAction(payload.gpId, payPlanValue, termValue, company.company))
        ]);

        return {
          company: company.company,
          rateResult,
          installmentResult,
          eftResult,
          success: true,
        };
      })
      .catch((error) => ({
        company: company.company,
        error,
        success: false,
      }))
      .finally(() => {
        pendingRequestsRef.current.delete(requestKey);
      });
  }).filter((promise) => promise != null);

  return Promise.all(promises);
};
const handleOtherCompaniesRates = async (
  otherCompanyItems,
  updatedState,
  value,
  name
) => {
  const promises = otherCompanyItems.map((item) => {
    const company = initialRows.find((row) => row.id === parseInt(item));
    if (!company) return null;

    const requestKey = `${company.company}-${updatedState.gpId}-${value}-${updatedState.term}`;

    // Check if this request is already pending
    if (pendingRequestsRef.current.has(requestKey)) {
      return null;
    }

    pendingRequestsRef.current.add(requestKey);

    const payload = {
      ...updatedState,
      companyCode: company.code,
    };

    const payPlanValue = name === "payPlanOptions" ? value : updatedState.payPlanOptions;
    const termValue = name === "term" ? value : updatedState.term;

    return Promise.all([
      dispatch(getAllDetialsRatesAction(payload.gpId, payPlanValue, termValue, company.company)),
      dispatch(getEFTByIdAction(payload.gpId, payPlanValue, termValue, company.company))
    ])
      .then((results) => ({
        company: company.company,
        results,
        success: true,
      }))
      .catch((error) => ({
        company: company.company,
        error,
        success: false,
      }))
      .finally(() => {
        pendingRequestsRef.current.delete(requestKey);
      });
  }).filter((promise) => promise != null);

  return Promise.all(promises);
};
useEffect(() => {
  // Clear pending requests when component unmounts
  return () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    pendingRequestsRef.current.clear();
    debouncedFetchRates.cancel();
  };
}, []);

  const handleInputChangeVehicle = (e, index) => {
    e.preventDefault();
    const { name, value } = e.target;

    const vehicleStateNew = [...vehicleState];
    vehicleStateNew[index] = {
      ...vehicleStateNew[index],
      [name]: value,
    };

    setVehicleState(vehicleStateNew);
    setFormState((prevState) => ({
      ...prevState,
      vehicle: vehicleStateNew,
    }));
  };

  const handleCloseInvoice = () => {
    setOpenInvoice(false);
  };

  const handleClickOpenInvoice = (companyName) => () => {
    if (!companyName) {
      console.error("Company name is undefined");
      return;
    }

    const selectedCompanyInstallments =
      installmentsAmount.find(
        (installmentGroup) =>
          installmentGroup?.[0]?.companyName?.toLowerCase() ===
          companyName.toLowerCase()
      ) || [];

    setOpenInvoice(true);
    setAllInstallments(selectedCompanyInstallments);
  };

  const getRates = async (payload, company) => {
    const companyName =
      company === "Pearl Holding"
        ? "pearl"
        : company === "National General"
        ? "nationalGeneral"
        : company === "Assurance America"
        ? "assuranceAmerica"
        : company === "Assurance America Economy"
        ? "assuranceAmerica-Economy"
        : company === "Assurance America Elite"
        ? "assuranceAmerica-Elite"
        : company === "United Auto"
        ? "unitedAuto"
        : company === "United Auto Premier"
        ? "unitedAutoPremier"
        : company === "Bristol West"
        ? "bristolWest"
        : company.toLowerCase();
    const result = await dispatch(getJSONAction(payload, companyName));
    return result;
  };

  const handleGetRates = async () => {
    if (checkedItemss.length === 0) {
      setNoCompanySelected(true);
      return;
    }
    try {
      setLoad(true);
      setNoCompanySelected(false);
      dispatch({ type: "RESET_ALL_RATES" });
      dispatch({ type: "CLEAR_RATE_ERRORS" });
      const validCheckedItems = checkedItemss.filter((item) => item != null);

      const companyNameRequestList = validCheckedItems
        .map((item) => {
          const company = initialRows.find((row) => row.id === parseInt(item));
          return company ? { companyName: company.company } : null;
        })
        .filter((entry) => entry != null);

      if (companyNameRequestList.length === 0) {
        console.error("No valid companies found to process.");
        setLoad(false);
        return;
      }

      const postCheckedData = {
        gpId: formState.gpId,
        companyNameRequestList,
      };
      await dispatch(postCheckedCompanyAction(postCheckedData));
      await dispatch(getcompanyDetialsAction(formState.gpId));
      const promises = validCheckedItems
        .map((item) => {
          const company = initialRows.find((row) => row.id === parseInt(item));
          if (company) {
            const payload = {
              ...formState,
              companyCode: company.code,
            };
            return getRates(payload, company.company)
              .then(() => {
                const ratePromise = dispatch(
                  getAllDetialsRatesAction(
                    payload.gpId,
                    payload.payPlanOptions,
                    formState.term,
                    company.company
                  )
                );

                const installmentPromise = dispatch(
                  getUnderwritingmsgAction(
                    payload.gpId,
                    company.company,
                  )
                );
                const eftPromise = dispatch(
                  getEFTByIdAction(
                    payload.gpId,
                    payload.payPlanOptions,
                    formState.term,
                    company.company
                  )
                );
                return Promise.all([
                  ratePromise,
                  installmentPromise,
                  eftPromise,
                ])
                  .then(([rateResult, installMentResult, eftResult]) => ({
                    company: company.company,
                    rateResult,
                    installMentResult,
                    eftResult,
                    success: true,
                  }))
                  .catch((error) => ({
                    company: company.company,
                    error,
                    success: false,
                  }));
              })
              .catch((error) => ({
                company: company.company,
                error,
                success: false,
              }));
          }
          return null;
        })
        .filter((promise) => promise != null);

      const results = await Promise.all(promises);

      const successfulResults = results.filter(({ success }) => success);

      results.forEach(
        ({ company, rateResult, vehicleResult, error, success }) => {
          if (!success) {
            console.error(`Error fetching data for ${company}:`, error);
          } else {
            console.log(`Rates for ${company}:`, rateResult);
            console.log(`Vehicle details for ${company}:`, vehicleResult);
          }
        }
      );

      setLoad(false);

      if (successfulResults.length === validCheckedItems.length) {
        setIsReRated(true);
      } else {
        console.warn(
          "Not all data were successfully fetched. isReRated not set to true."
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoad(false);
    }
  };

  const newCompanyNames = ["Amwins", "Embark", "Pearl Holding", "United Auto","Bristol West","Kemper","Responsive"];

  return (
    <Box
      maxWidth="xl"
      sx={{
        backgroundColor: "#fff",
        margin: "0 auto",
        border: "#E7E7E7 solid 1px",
        padding: isMobile ? "10px" : "20px",
        borderRadius: "4px",
         '@media (min-width: 768px) and (max-width: 1024px)': {
            minHeight: '200vh',
            height: 'auto',
            overflowY: 'auto',
          },
          '@media (min-width: 1024px) and (min-height: 1366px)': {
            height: 'auto',
            minHeight: '170vh',
          },
      }}
    >
      <Paper
        elevation={0}
        style={{
          borderRadius: 4,
          backgroundColor: "#fff",
          borderBottom: "1px solid #e3e3e3",
          padding: isMobile ? "15px 0 10px" : "30px 0 20px",
        }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Grid item>
            <Typography
              id="comparisonsection"
              variant={isMobile ? "h6" : "h5"}
              fontWeight="600"
              sx={{ fontFamily: '"Poppins", sans-serif' }}
            >
              Comparison Section
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Box sx={{ mt: 2, flexGrow: 1 }}>
        <Grid container spacing={1} sx={{ fontFamily: '"Poppins", sans-serif' }}>
          <Grid container item xs={12} sm={12} spacing={1}>
            <Grid item xs={12} sm={6} md={3} sx={{ marginBottom: "10px" }}>
              <Typography id="changenameinsuredto" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                Change Name Insured To
                <TextField
                   select={"select"}
                    SelectProps={{
                    MenuProps: {
                      disableScrollLock: true,
                      PaperProps: {
                        style: {
                        }
                      }
                    }
                  }}
                  sx={{ fontFamily: '"Poppins", sans-serif' }}
                  fullWidth
                  placeholder="Change Name Insured To"
                   name={"changeNameInsuredTo"}
                  value={formState["changeNameInsuredTo"]}
                  size={isMobile ? "small" : "medium"}
                  onChange={(e) => handleInputChange(e)}
                >
                  {simplifiedDriverDetails.map((driver, i) => (
                    <MenuItem
                      key={i}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      value={driver.fullName}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {driver.fullName}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} sx={{ marginBottom: "10px" }}>
              <Typography id="LiabBI" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                Liab BI
                <TextField
                   select={"select"}
                    SelectProps={{
                      MenuProps: {
                        disableScrollLock: true,
                        PaperProps: {
                          style: {
                          }
                        }
                      }
                    }}
                  fullWidth
                  placeholder="Liab BI"
                  name={"liabbi"}
                  value={formState["liabbi"]}
                  size={isMobile ? "small" : "medium"}
                  onChange={(e) => handleInputChange(e)}
                  sx={{
                    fontFamily: '"Poppins", sans-serif',
                    minHeight: "55px",
                  }}
                >
                  {liabbi.map((option) => (
                    <MenuItem
                      key={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      value={option.value}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography id="LiabPD" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                Liab PD
                <TextField
                   select={"select"}
                    SelectProps={{
                    MenuProps: {
                      disableScrollLock: true,
                      PaperProps: {
                        style: {
                        }
                      }
                    }
                  }}
                  sx={{ fontFamily: '"Poppins", sans-serif' }}
                  fullWidth
                  placeholder="Liab PD"
                 name={"liabpd"}
                  value={formState["liabpd"]}
                  size={isMobile ? "small" : "medium"}
                  onChange={(e) => handleInputChange(e)}
                  disabled={["SM", "100000CSL", "300000CSL", "500000CSL"].includes(formState["liabbi"])}
                >
                  {liabpd.map((option) => (
                    <MenuItem
                      key={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      value={option.value}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography id="PIPDED" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                PIP DED
                <TextField
                   select={"select"}
                    SelectProps={{
                    MenuProps: {
                      disableScrollLock: true,
                      PaperProps: {
                        style: {
                        }
                      }
                    }
                  }}
                  sx={{ fontFamily: '"Poppins", sans-serif' }}
                  fullWidth
                  placeholder="PIP DED"
                 name={"pipDed"}
                  value={formState["pipDed"]}
                  size={isMobile ? "small" : "medium"}
                  onChange={(e) => handleInputChange(e)}
                >
                  {pipDed.map((option) => (
                    <MenuItem
                      key={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      value={option.value}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
          </Grid>
          <Grid container item xs={12} sm={12} spacing={1}>
            <Grid item xs={12} sm={6} md={3} sx={{ marginBottom: "10px" }}>
              <Typography id="PIPDEDoption" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                PIP DED Option
                <TextField
                   select={"select"}
                    SelectProps={{
                      MenuProps: {
                        disableScrollLock: true,
                        PaperProps: {
                          style: {
                          }
                        }
                      }
                    }}
                  sx={{
                    fontFamily: '"Poppins", sans-serif',
                    marginTop: "5px",
                  }}
                  fullWidth
                  placeholder="PIP DED Option"
                 name={"pipDedOption"}
                  size={isMobile ? "small" : "medium"}
                  value={formState["pipDedOption"]}
                  onChange={(e) => handleInputChange(e)}
                >
                  {pipDedOption.map((option) => (
                    <MenuItem
                      key={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      value={option.value}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} sx={{ marginBottom: "10px" }}>
              <Typography id="UMBI" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                UMBI
                <TextField
                  select={"select"}
                   SelectProps={{
                    MenuProps: {
                      disableScrollLock: true,
                      PaperProps: {
                        style: {
                        }
                      }
                    }
                  }}
                  sx={{
                    fontFamily: '"Poppins", sans-serif',
                    marginTop: "5px",
                  }}
                  fullWidth
                  placeholder="UMBI"
                   name={"umbi"}
                  size={isMobile ? "small" : "medium"}
                  value={formState["umbi"]}
                  onChange={(e) => handleInputChange(e)}
                >
                  {umbi.map((option) => (
                    <MenuItem
                      key={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      value={option.value}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} sx={{ marginBottom: "10px" }}>
              <Typography id="UMPD" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                UMPD
                <TextField
                  select={"select"}
                   SelectProps={{
                    MenuProps: {
                      disableScrollLock: true,
                      PaperProps: {
                        style: {
                        }
                      }
                    }
                  }}
                  sx={{
                    fontFamily: '"Poppins", sans-serif',
                    marginTop: "5px",
                  }}
                  fullWidth
                  placeholder="UMPD"
                  name={"umpd"}
                  size={isMobile ? "small" : "medium"}
                  value={formState["umpd"]}
                  onChange={(e) => handleInputChange(e)}
                >
                  {umpd.map((option) => (
                    <MenuItem
                      key={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      value={option.value}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography id="UMstacked" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                UM Stacked
                <TextField
                  select={"select"}
                   SelectProps={{
                      MenuProps: {
                        disableScrollLock: true,
                        PaperProps: {
                          style: {
                          }
                        }
                      }
                    }}
                  sx={{
                    fontFamily: '"Poppins", sans-serif',
                    marginTop: "5px",
                  }}
                  fullWidth
                  placeholder="UM Stacked"
                 name={"umStacked"}
                  size={isMobile ? "small" : "medium"}
                  value={formState["umStacked"]}
                  onChange={(e) => handleInputChange(e)}
                >
                  {CommonYesNo.map((option) => (
                    <MenuItem
                      key={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      value={option.value}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography id="medpay" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                Med Pay
                <TextField
                  select
                   SelectProps={{
                    MenuProps: {
                      disableScrollLock: true,
                      PaperProps: {
                        style: {
                        }
                      }
                    }
                  }}
                  sx={{
                    fontFamily: '"Poppins", sans-serif',
                    marginTop: "5px",
                  }}
                  fullWidth
                  placeholder="Med Pay"
                  name={"medPay"}
                  size={isMobile ? "small" : "medium"}
                  value={formState.medPay}
                  onChange={handleInputChange}
                >
                  {medPay.map((option) => (
                    <MenuItem
                      key={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      value={option.value}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
          </Grid>
          <hr
            style={{
              borderTop: "1px solid #ccc",
              width: "100%",
              marginTop: "30px",
            }}
          />
          <Grid item xs={12} sm={12}>
            {vehicleState.length > 0 &&
              vehicleState.map((vehicle, index) => (
                <Grid container item xs={12} sm={12} spacing={1} key={index}>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: '"Poppins", sans-serif',
                        color: "#242929",
                        fontWeight: "bold",
                        marginTop: "10px",
                      }}
                    >
                      {`#${index + 1} ${vehicle.manufacturer} ${
                          vehicle.model
                        }`}
                        </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.9}>
                    <Typography id="comp" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                      Comp
                      <TextField
                        select
                         SelectProps={{
                          MenuProps: {
                            disableScrollLock: true,
                            PaperProps: {
                              style: {
                              }
                            }
                          }
                        }}
                        sx={{ fontFamily: '"Poppins", sans-serif' }}
                        fullWidth
                        placeholder="Comp"
                        name={"comp"}
                        value={vehicle.comp}
                        size={isMobile ? "small" : "medium"}
                        onChange={(e) => handleInputChangeVehicle(e, index)}
                      >
                        {comp.map((option) => (
                          <MenuItem
                            key={option.value}
                            value={option.value}
                            sx={{ fontFamily: '"Poppins", sans-serif' }}
                          >
                            <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                              {option.label}
                            </Box>
                          </MenuItem>
                        ))}
                      </TextField>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.9}>
                    <Typography id="coll" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                      Coll
                      <TextField
                        select
                         SelectProps={{
                          MenuProps: {
                            disableScrollLock: true,
                            PaperProps: {
                              style: {
                              }
                            }
                          }
                        }}
                        sx={{ fontFamily: '"Poppins", sans-serif' }}
                        size={isMobile ? "small" : "medium"}
                        fullWidth
                        placeholder="Coll"
                        name={"coll"}
                        value={vehicle.coll}
                        onChange={(e) => handleInputChangeVehicle(e, index)}
                      >
                        {coll.map((option) => (
                          <MenuItem
                            key={option.value}
                            value={option.value}
                            sx={{ fontFamily: '"Poppins", sans-serif' }}
                          >
                            <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                              {option.label}
                            </Box>
                          </MenuItem>
                        ))}
                      </TextField>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.9}>
                    <Typography id="roadside" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                      Roadside
                      <TextField
                         select={"select"}
                          SelectProps={{
                          MenuProps: {
                            disableScrollLock: true,
                            PaperProps: {
                              style: {
                              }
                            }
                          }
                        }}
                        sx={{ fontFamily: '"Poppins", sans-serif' }}
                        size={isMobile ? "small" : "medium"}
                        fullWidth
                        placeholder="Roadside"
                        name={"roadside"}
                        value={vehicle.roadside}
                        onChange={(e) => handleInputChangeVehicle(e, index)}
                      >
                        {Roadside.map((option) => (
                          <MenuItem
                            sx={{ fontFamily: '"Poppins", sans-serif' }}
                            key={option.value}
                            value={option.value}
                          >
                            <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                              {option.label}
                            </Box>
                          </MenuItem>
                        ))}
                      </TextField>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <Typography  id="rental" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                      Rental
                      <TextField
                        select={"select"}
                         SelectProps={{
                          MenuProps: {
                            disableScrollLock: true,
                            PaperProps: {
                              style: {
                              }
                            }
                          }
                        }}
                        sx={{ fontFamily: '"Poppins", sans-serif' }}
                        size={isMobile ? "small" : "medium"}
                        fullWidth
                        placeholder="Rental"
                        name={"rental"}
                        value={vehicle.rental}
                        onChange={(e) => handleInputChangeVehicle(e, index)}
                      >
                        {Rental.map((option) => (
                          <MenuItem
                            key={option.value}
                            sx={{ fontFamily: '"Poppins", sans-serif' }}
                            value={option.value}
                          >
                            <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                              {option.label}
                            </Box>
                          </MenuItem>
                        ))}
                      </TextField>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.9}>
                    <Typography  id="tow" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                      Tow
                      <TextField
                        select={"select"}
                         SelectProps={{
                          MenuProps: {
                            disableScrollLock: true,
                            PaperProps: {
                              style: {
                              }
                            }
                          }
                        }}
                        sx={{ fontFamily: '"Poppins", sans-serif' }}
                        size={isMobile ? "small" : "medium"}
                        fullWidth
                        placeholder="Tow"
                         name={"tow"}
                        value={vehicle.tow}
                        onChange={(e) => handleInputChangeVehicle(e, index)}
                      >
                        {Roadside.map((option) => (
                          <MenuItem
                            key={option.value}
                            sx={{ fontFamily: '"Poppins", sans-serif' }}
                            value={option.value}
                          >
                            <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                              {option.label}
                            </Box>
                          </MenuItem>
                        ))}
                      </TextField>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.9}>
                    <Typography  id="safety" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                      Safety
                      <TextField
                        select={"select"}
                         SelectProps={{
                          MenuProps: {
                            disableScrollLock: true,
                            PaperProps: {
                              style: {
                              }
                            }
                          }
                        }}
                        sx={{ fontFamily: '"Poppins", sans-serif' }}
                        size={isMobile ? "small" : "medium"}
                        fullWidth
                        placeholder="safety"
                        name={"safety"}
                        value={vehicle.safety}
                        onChange={(e) => handleInputChangeVehicle(e, index)}
                      >
                        {CommonYesNo.map((option) => (
                          <MenuItem
                            key={option.value}
                            sx={{ fontFamily: '"Poppins", sans-serif' }}
                            value={option.value}
                          >
                            <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                              {option.label}
                            </Box>
                          </MenuItem>
                        ))}
                      </TextField>
                    </Typography>
                  </Grid>
                </Grid>
              ))}
          </Grid>

          <Grid
            container
            item
            xs={12}
            sm={12}
            spacing={1}
            sx={{ marginTop: "10px" }}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{
                color: "black",
                padding: 5,
                marginLeft: 5,
                fontFamily: '"Poppins", sans-serif',
              }}
              sx={{ position: "sticky" }}
            >
              <Typography
               id="companyselection"
                variant={isMobile ? "h6" : "h5"}
                fontWeight="600"
                sx={{ fontFamily: '"Poppins", sans-serif' }}
              >
                Company Selection
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              style={{
                padding: 5,
                marginLeft: 5,
                width: "100%",
                overflowX: "auto",
                fontFamily: '"Poppins", sans-serif',
              }}
            >
              <table className={classes.table}>
                <thead className={classes.thead}>
                  <tr>
                    <th className="styled-table-heading" style={{ padding: 12 }}>
                      #
                    </th>
                    <th className="styled-table-heading" style={{ padding: 12 }}>
                      Company
                    </th>
                    <th className="styled-table-heading" style={{ padding: 12 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectAll}
                            onChange={handleSelectAllChange}
                            name="select-all"
                            color="primary"
                            size={isMobile ? "small" : "medium"}
                          />
                        }
                        label="Select All"
                      />
                      Rates
                    </th>
                  </tr>
                </thead>
                <tbody className={classes.tbody}>
                  {initialRows.length === 0 ? (
                    <tr>
                      <td id="nocompanyfound" className={classes.td} colSpan="3" style={{
                        textAlign: "center",
                        padding: "20px",
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#888",
                      }}>
                        No Company found
                      </td>
                    </tr>
                  ) : (
                    initialRows.map((row, index) => (
                      <tr className="styled-table-row" key={row.id}>
                        <td className={classes.td}>{index + 1}</td>
                        <td className={classes.td}>
                          <div className={classes.logoContainer}>
                            {companyLogos[row.company] && (
                              <Box
                                sx={{
                                  width: "100px",
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  position: "relative"
                                }}
                              >
                                {newCompanyNames.includes(row.company) && (
                                  <Chip className="new-label" label="New" color="error" size="small" />
                                )}
                                <img
                                  src={companyLogos[row.company]}
                                  alt={`${row.company} Logo`}
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              </Box>
                            )}
                            {row.company}
                          </div>
                        </td>
                        <td className={classes.td}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkedItemss.includes(row.id.toString())}
                                onChange={handleCheckChanges}
                                name={`rates-${row.id}`}
                                value={row.id}
                                color="primary"
                                size={isMobile ? "small" : "medium"}
                              />
                            }
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mb: 2,
                width: '100%',
                margin: '15px 10px 0 0'
              }}
            >
              <Button
                variant="outlined"
                onClick={handleOpenPolicy}
              >
                Create Policy
              </Button>

              <Button
                onClick={handleGetRates}
                variant="outlined"
                  disabled={load}
              >
                {loading ? (
                  <CircleOutlined size="24" color="secondary" />
                ) : isReRated ? (
                  "Re-rate"
                ) : (
                  "Get Rates"
                )}
              </Button>
            </Box>
          </Grid>
          <Dialog
            open={openPolicy}
            onClose={handleClosePolicy}
             fullWidth
              maxWidth="sm"
                fullScreen={window.innerWidth < 600}
                sx={{
                  '& .MuiDialog-paper': {
                    width: '70%',
                    margin: { xs: 0, sm: '12px' },
                    maxHeight: { xs: 'calc(50% + 10px)', sm: 'calc(100% - 34px)' },
                    position: 'absolute',
                    top: { xs: '20px', sm: '12px' },
                    alignSelf: 'flex-start',
                    overflow: 'hidden',
                  },
                  '& .MuiDialog-container': {
                    alignItems: 'flex-start',
                    padding: { xs: '20px 0', sm: 0 }
                  }
                }}
                    >
            <DialogTitle>Create New Policy</DialogTitle>
            <DialogContent>
              <Box sx={{ mt: 2 }}>
                <Typography>Policy Number</Typography>
                <TextField
                  fullWidth
                   SelectProps={{
                    MenuProps: {
                      disableScrollLock: true,
                      PaperProps: {
                        style: {
                        }
                      }
                    }
                  }}
                  margin="normal"
                  value={policyNumber}
                  onChange={(e) => setPolicyNumber(e.target.value)}
                  sx={{ mb: 2 }}
                  size={isMobile ? "small" : "medium"}
                />

                <FormControl fullWidth margin="normal">
                  <Typography>Select Company</Typography>
                  <Select
                    value={selectedCompanyPolicy}
                    label="Select Company"
                    onChange={(e) => setSelectedCompanyPolicy(e.target.value)}
                    size={isMobile ? "small" : "medium"}
                  >
                    {priorInsuranceCarriersOptionss.map((company) => (
                      <MenuItem key={company.id} value={company.value}>
                        {company.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: '"Poppins", sans-serif', mb: 1 }}
                    >
                      Term
                    </Typography>
                    <TextField
                      select
                       SelectProps={{
                        MenuProps: {
                          disableScrollLock: true,
                          PaperProps: {
                            style: {
                            }
                          }
                        }
                      }}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      fullWidth
                      placeholder="Term"
                      name="term"
                      value={formState["term"]}
                      onChange={(e) => handleInputChange(e)}
                      disabled={load}
                      size={isMobile ? "small" : "medium"}
                    >
                      {TermTenture.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          sx={{ fontFamily: '"Poppins", sans-serif' }}
                        >
                          <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                            {option.label}
                          </Box>
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: '"Poppins", sans-serif', mb: 1 }}
                    >
                      Pay Plan Options
                    </Typography>
                    <TextField
                             SelectProps={{
                        MenuProps: {
                          disableScrollLock: true,
                          PaperProps: {
                            style: {
                            }
                          }
                        }
                      }}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                      fullWidth
                      placeholder="Pay Plan Options"
                      name="payPlanOptions"
                      value={formState["payPlanOptions"]}
                      onChange={(e) => handleInputChange(e)}
                      disabled={load}
                      size={isMobile ? "small" : "medium"}
                    >
                      {payPlanOptionIns.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          sx={{ fontFamily: '"Poppins", sans-serif' }}
                        >
                          <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                            {option.label}
                          </Box>
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClosePolicy} color="primary" size={isMobile ? "small" : "medium"}>
                Cancel
              </Button>
              <Button
                onClick={handleSubmitPolicy}
                className="btn-primary"
                variant="contained"
                size={isMobile ? "small" : "medium"}
              >
                Create
              </Button>
            </DialogActions>
          </Dialog>
          <Grid container item xs={12} sm={12} spacing={1}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography id="term" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                Term
                <TextField
                  select={"select"}
                        SelectProps={{
                    MenuProps: {
                      disableScrollLock: true,
                      PaperProps: {
                        style: {
                        }
                      }
                    }
                  }}
                  sx={{
                    fontFamily: '"Poppins", sans-serif',
                    marginTop: "5px",
                  }}
                  fullWidth
                  placeholder="Term"
                  name={"term"}
                  value={formState["term"]}
                  onChange={(e) => handleInputChange(e)}
                  disabled={load}
                  size={isMobile ? "small" : "medium"}
                >
                  {TermTenture.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography id="payplanoptions" variant="body1" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                Pay Plan Options
                <TextField
                  select={"select"}
                   SelectProps={{
                      MenuProps: {
                        disableScrollLock: true,
                        PaperProps: {
                          style: {
                          }
                        }
                      }
                    }}
                  sx={{
                    fontFamily: '"Poppins", sans-serif',
                    marginTop: "5px",
                  }}
                  fullWidth
                  placeholder="Pay Plan Options"
                 name={"payPlanOptions"}
                  value={formState["payPlanOptions"]}
                  onChange={(e) => handleInputChange(e)}
                  disabled={load}
                  size={isMobile ? "small" : "medium"}
                >
                  {payPlanOptionIns.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      sx={{ fontFamily: '"Poppins", sans-serif' }}
                    >
                      <Box sx={{ fontFamily: '"Poppins", sans-serif' }}>
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Box
              sx={{
                border: "#E7E7E7 solid 1px",
                marginTop: "1rem",
                borderRadius: "4px",
                overflowX: 'auto'
              }}
            >
              <Table
                aria-label="collapsible table"
                size={isMobile ? "small" : "medium"}
                style={{
                  borderSpacing: "0",
                  border: "none",
                  padding: "10px 0",
                  minWidth: isMobile ? '800px' : '100%'
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        backgroundColor: "transparent",
                        color: "#242929",
                        fontSize: "1rem",
                        fontWeight: "bold",
                        fontFamily: '"Poppins", sans-serif',
                        border: "none",
                      },
                    }}
                  >
                    <TableCell className="styled-table-heading" align="left"></TableCell>
                    <TableCell id="quote" className="styled-table-heading" align="left">Quote</TableCell>
                    <TableCell id="companyname" className="styled-table-heading">Company Name</TableCell>
                    <TableCell id="totalpremium" className="styled-table-heading" align="left">Total Premium</TableCell>
                    <TableCell id="downpayment" className="styled-table-heading" align="left">Down Payment</TableCell>
                    <TableCell id="schedules" className="styled-table-heading" align="left">Schedules</TableCell>
                    <TableCell id="term" className="styled-table-heading" align="left">Term</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {!selectedCompanies.length > 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center" sx={{
                        backgroundColor: "#F8F8F8",
                        fontSize: "14px",
                        fontFamily: '"Poppins", sans-serif',
                        color: "#757575",
                      }}>
                        Please select a company
                      </TableCell>
                    </TableRow>
                  ) : (
                    sortedRates.map((rate, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor: "#F8F8F8",
                          "& td": {
                            borderBottom: "#E7E7E7 solid 1px",
                            fontSize: "14px",
                            fontFamily: '"Poppins", sans-serif',
                          },
                        }}
                        className="styled-table-row"
                      >
                        <TableCell>
                          {rate.hasError ? (
                            load ? (
                              <CircularProgress size={20} />
                            ) : (
                              <>
                                <IconButton onClick={handleOpenError} size="small">
                                  <ErrorOutlineIcon sx={{ color: "red", fontSize: 20 }} />
                                </IconButton>
                                <Dialog
                                  open={openError}
                                  onClose={handleCloseError}
                                  maxWidth="xs"
                                  fullWidth
                                >
                                  <DialogTitle sx={{ backgroundColor: "#ffebee", color: "#d32f2f", fontWeight: "bold" }}>
                                    Error
                                  </DialogTitle>
                                  <DialogContent sx={{ p: 2, display: "flex", alignItems: "center", gap: 1 }}>
                                    <ErrorOutlineIcon sx={{ color: "#d32f2f", fontSize: 24 }} />
                                    <Typography variant="body2" color="error">
                                      {rate.errorMessage}
                                    </Typography>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={handleCloseError} variant="contained" color="error">
                                      Close
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              </>
                            )
                          ) : load ? (
                            <CircularProgress size={20} />
                          ) : (
                            <GridCheckCircleIcon sx={{ color: "green", fontSize: 20 }} />
                          )}
                        </TableCell>
                        <TableCell>
                          {rate.hasError ? (
                            <Typography color="error" variant="body2">
                              {rate.errorMessage}
                            </Typography>
                          ) : (
                            <>
                              <UnderwritingMessage underWritingMsg={underWritingMsg} currentCompany={rate.companyName} />
                              <a
                                href={rate.bridgingLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  fontFamily: '"Poppins", sans-serif',
                                  marginLeft: '10px',
                                  textDecoration: "none",
                                }}
                              >
                                Bridge
                              </a>
                              <Button
                                onClick={() => handleOpenDialog(rate.companyName || "")}
                                size={isMobile ? "small" : "medium"}
                                id="details"
                              >
                                Details
                              </Button>
                              <Dialog
                                open={open}
                                onClose={handleClose}
                                maxWidth="md"
                                fullWidth
                                disableScrollLock={true}
                                keepMounted={false}
                                hideBackdrop={true}
                                style={{ zIndex: 1300 }}
                              >
                                <DialogTitle>
                                    Breakdown Details
                                  <IconButton
                                    aria-label="close"
                                    onClick={handleClose}
                                    sx={{
                                      position: "absolute",
                                      right: 8,
                                      top: 8,
                                      color: (theme) => theme.palette.grey[500],
                                    }}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </DialogTitle>
                                <DialogContent>
                                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                                    <Grid container spacing={2}>
                                      {selectedCompany?.vehicleDetailsResponseList?.map(
                                        (vehicle, index) => (
                                          <Grid item xs={12} sm={6} md={4} key={vehicle.id}>
                                            <Box
                                              sx={{
                                                border: "1px solid #e0e0e0",
                                                borderRadius: "12px",
                                                padding: "16px",
                                                backgroundColor: "#f9f9f9",
                                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                                transition: "transform 0.3s ease",
                                                "&:hover": {
                                                  transform: "scale(1.02)",
                                                },
                                              }}
                                            >
                                              <Typography
                                                fontWeight="bold"
                                                fontSize="16px"
                                                color="primary"
                                                gutterBottom
                                                component="div"
                                                sx={{
                                                  borderBottom: "2px solid",
                                                  paddingBottom: "8px",
                                                }}
                                              >
                                                Vehicle {index + 1}
                                              </Typography>
                                              <TableContainer>
                                                <Table size="small" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                                                  <TableBody>
                                                    {[
                                                      { label: "BI", value: vehicle.bi },
                                                      { label: "COLL", value: vehicle.coll },
                                                      { label: "COMP", value: vehicle.comp },
                                                      { label: "PD", value: vehicle.pd },
                                                      { label: "UM", value: vehicle.um },
                                                      { label: "TOW", value: vehicle.tow },
                                                      { label: "PIP", value: vehicle.pip },
                                                      { label: "REIM", value: vehicle.rreim },
                                                        { label: "MEDP", value: vehicle.medp },
                                                    ].map((item) => (
                                                      <TableRow key={item.label}>
                                                        <TableCell sx={{ fontWeight: "bold" }}>
                                                          {item.label}
                                                        </TableCell>
                                                        <TableCell>
                                                          ${item.value || "0"}
                                                        </TableCell>
                                                      </TableRow>
                                                    ))}
                                                  </TableBody>
                                                </Table>
                                              </TableContainer>
                                            </Box>
                                          </Grid>
                                        )
                                      )}
                                    </Grid>

                                    {/* {selectedCompany?.vehicleFeesResponse && (
                                      <Box sx={{ width: "100%", marginTop: "20px" }}>
                                        <Typography
                                          fontWeight="bold"
                                          fontSize="18px"
                                          color="primary"
                                          gutterBottom
                                          component="div"
                                          sx={{
                                            borderBottom: "2px solid",
                                            paddingBottom: "8px",
                                          }}
                                        >
                                          Policy Fees
                                        </Typography>
                                        <Grid container spacing={2}>
                                          <Grid item xs={12} sm={6}>
                                            <TableContainer>
                                              <Table size="small">
                                                <TableBody>
                                                  <TableRow>
                                                    <TableCell sx={{ fontWeight: "bold" }}>
                                                      Policy Fee
                                                    </TableCell>
                                                    <TableCell>
                                                      ${selectedCompany.vehicleFeesResponse.policyFee || "0.00"}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell sx={{ fontWeight: "bold" }}>
                                                      Underwriting Fee
                                                    </TableCell>
                                                    <TableCell>
                                                      ${selectedCompany.vehicleFeesResponse.underwritingFee || "0.00"}
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    )} */}
                                    {selectedCompany?.vehicleFeesResponse &&
 Object.keys(selectedCompany.vehicleFeesResponse).length > 0 && (
  <Box sx={{ width: "100%", marginTop: "20px" }}>
    <Typography
      fontWeight="bold"
      fontSize="18px"
      color="primary"
      gutterBottom
      component="div"
      sx={{
        borderBottom: "2px solid",
        paddingBottom: "8px",
      }}
    >
      Policy Fees
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TableContainer>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Policy Fee
                </TableCell>
                <TableCell>
                  ${selectedCompany.vehicleFeesResponse.policyFee || "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Underwriting Fee
                </TableCell>
                <TableCell>
                  ${selectedCompany.vehicleFeesResponse.underwritingFee || "0.00"}
                </TableCell>
              </TableRow>
               <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  SetUp Fee
                </TableCell>
                <TableCell>
                  ${selectedCompany.vehicleFeesResponse.setupFee || "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Sr22 Fee
                </TableCell>
                <TableCell>
                  ${selectedCompany.vehicleFeesResponse.sr22Fee || "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  </Box>
)}


                                    {eftvalue.length > 0 &&
                                      eftvalue.some(
                                        (eft) =>
                                          selectedCompanyEFT?.companyName?.toLowerCase() ===
                                          eft.companyName.toLowerCase()
                                      ) && (
                                        <Box sx={{ width: "100%", marginTop: "20px" }}>
                                          <Typography
                                            fontWeight="bold"
                                            fontSize="18px"
                                            color="primary"
                                            gutterBottom
                                            component="div"
                                            sx={{
                                              borderBottom: "2px solid",
                                              paddingBottom: "8px",
                                            }}
                                          >
                                            Other Payment Plan Options
                                          </Typography>
                                          <Grid container spacing={2}>
                                            {eftvalue
                                              .filter(
                                                (eft) =>
                                                  selectedCompanyEFT?.companyName?.toLowerCase() ===
                                                  eft.companyName.toLowerCase()
                                              )
                                              .map((eft, index) => (
                                                <Grid item xs={12} sm={6} md={4} key={index}>
                                                  <Box
                                                    sx={{
                                                      border: "1px solid #e0e0e0",
                                                      borderRadius: "12px",
                                                      padding: "16px",
                                                      backgroundColor: "#f5f5f5",
                                                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                                      transition: "transform 0.3s ease",
                                                      "&:hover": {
                                                        transform: "scale(1.02)",
                                                      },
                                                    }}
                                                  >
                                                    <Typography
                                                      fontWeight="bold"
                                                      fontSize="16px"
                                                      color="secondary"
                                                      gutterBottom
                                                    >
                                                      Plan: {eft.planCode}
                                                    </Typography>
                                                    <TableContainer>
                                                      <Table size="small">
                                                        <TableBody>
                                                          <TableRow>
                                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                              Plan Option
                                                            </TableCell>
                                                            <TableCell>
                                                              {eft.planOption}
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                              Down Payment
                                                            </TableCell>
                                                            <TableCell>
                                                              ${eft.downPaymentAmt}
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                              Installment Payment
                                                            </TableCell>
                                                            <TableCell>
                                                              ${eft.installmentPayment}
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                              Number of Payments
                                                            </TableCell>
                                                            <TableCell>
                                                              {eft.numberOfPayments}
                                                            </TableCell>
                                                          </TableRow>
                                                           <TableRow>
                                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                              Installment Fee
                                                            </TableCell>
                                                            <TableCell>
                                                              ${eft.installmentFee ||0}
                                                            </TableCell>
                                                          </TableRow>
                                                        </TableBody>
                                                      </Table>
                                                    </TableContainer>
                                                  </Box>
                                                </Grid>
                                              ))}
                                          </Grid>
                                        </Box>
                                      )}
                                  </Box>
                                </DialogContent>
                              </Dialog>
                            </>
                          )}
                        </TableCell>

                        <TableCell>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            {getCompanyLogo(rate.companyName)}
                            <Typography>{rate.companyName}</Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          {rate.totalPremium
                            ? formattedCurrency(rate.totalPremium)
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {rate.depositAmt
                            ? formattedCurrency(rate.depositAmt)
                            : "-"}
                        </TableCell>
                        <TableCell align="left" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                          <Button
                           id="detailsbutton"
                            onClick={handleClickOpenInvoice(rate.companyName || "")}
                            sx={{ fontFamily: '"Poppins", sans-serif' }}
                            size={isMobile ? "small" : "medium"}
                          >
                            Installment Details
                          </Button>
                          <Dialog
                            open={openInvoice}
                            onClose={handleCloseInvoice}
                            maxWidth="lg"
                            fullWidth
                            disableScrollLock={true}
                            keepMounted={false}
                            hideBackdrop={true}
                            style={{ zIndex: 1300 }}
                          >
                            <DialogTitle>
                              <Typography
                               id="scheduledetails"
                                sx={{
                                  fontFamily: '"Poppins", sans-serif',
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                                component="div"
                              >
                                Schedule Details
                              </Typography>
                              <IconButton
                                aria-label="close"
                                onClick={handleCloseInvoice}
                                sx={{
                                  position: "absolute",
                                  right: 8,
                                  top: 8,
                                  color: (theme) => theme.palette.grey[500],
                                }}
                              >
                                <CloseIcon />
                              </IconButton>
                            </DialogTitle>

                            <DialogContent>
                              <Box sx={{ margin: 1 }}>
                                <Table
                                  size="small"
                                  aria-label="installment details"
                                  sx={{ border: "#E7E7E7 solid 1px" }}
                                >
                                  <TableHead>
                                    <TableRow>
                                      <TableCell id="installmentnumber" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                                        Installment Number
                                      </TableCell>
                                      <TableCell id="amount" sx={{ fontFamily: '"Poppins", sans-serif' }}>
                                        Amount
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {allInstallments.map((installment, index) => (
                                      <TableRow
                                        key={installment.id}
                                        sx={{
                                          backgroundColor: index % 2 === 0 ? "white" : "#F8F8F8",
                                        }}
                                      >
                                        <TableCell sx={{ fontFamily: '"Poppins", sans-serif' }}>
                                          {installment.installmentNumber}
                                        </TableCell>
                                        <TableCell sx={{ fontFamily: '"Poppins", sans-serif' }}>
                                          {formattedCurrency(installment.installmentAmt)}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </Box>
                            </DialogContent>
                          </Dialog>
                        </TableCell>
                        <TableCell>{rate.terms || "-"}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ fontFamily: '"Poppins", sans-serif' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CompareQuotesTab;